module.exports = __webpack_public_path__ + "img/class-banner.40c264f.webp";